/* eslint-disable */
import { useEffect, useState } from 'react';
import {
	ChevronDown, Loader2, X,
} from 'lucide-react';
import moment from 'moment';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuCheckboxItem,
	DropdownMenuTrigger,
	DropdownMenuSeparator,
} from '@/Components/ui/dropdown-menu';
import { Button } from '@/Components/ui/button';
import aiPackaging from '@/Services/aiPackaging.services';

const BatchPicker = (props) => {
	const {
		dateRange, selectedBatches, setSelectedBatches, onBatchSelect, variantId, productId,
	} = props;
	const [batchList, setBatchList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');

	useEffect(() => {
		const fetchBatches = async () => {
			if (!dateRange?.from || !dateRange?.to) return;

			setIsLoading(true);
			try {
				const req = {
					data: {
						dateRangeFilter: {
							from: moment(dateRange.from).format('YYYY-MM-DD'),
							to: moment(dateRange.to).format('YYYY-MM-DD'),
						},
						...(variantId && {
							variantId,
						}),
						...(productId && {
							productId,
						}),
					},
				};
				const response = await aiPackaging.fetchBatchList(req);
				if (response?.statusCode === 200) {
					setBatchList(response?.data || []);
				} else {
					setBatchList([]);
				}
			} catch (error) {
				// console.error('Failed to fetch batches', error);
				setBatchList([]);
			} finally {
				setIsLoading(false);
			}
		};

		fetchBatches();
		// Clear selection when date changes, as batches might not be valid anymore
		// setSelectedBatches([]);
	}, [dateRange?.from, dateRange?.to, setSelectedBatches, variantId, productId]);

	const handleSelect = (batch) => {
		setSelectedBatches((prev) => {
			const exists = prev.find((b) => b.grnItemBatchId === batch.grnItemBatchId);
			if (exists) {
				return prev.filter((b) => b.grnItemBatchId !== batch.grnItemBatchId);
			}
			if (onBatchSelect) {
				onBatchSelect(batch);
			}
			// return [...prev, batch];
			return [batch];
		});
	};

	const clearSelection = (e) => {
		e.stopPropagation();
		setSelectedBatches([]);
		setSearchTerm('');
	};

	const filteredBatches = batchList.filter((batch) => {
		if (!searchTerm) return true;
		const searchLower = searchTerm.toLowerCase();
		return (
			batch.batchName?.toLowerCase().includes(searchLower) ||
			(
				!variantId && !productId && (
					batch.productName?.toLowerCase().includes(searchLower) ||
					batch.variantName?.toLowerCase().includes(searchLower)
				)
			)
		);
	});

	const getTriggerLabel = () => {
		if (isLoading) return null;
		if (selectedBatches?.length === 0) return 'Select FG Batch';
		if (selectedBatches?.length === 1) return selectedBatches[0].batchName;
		return `${selectedBatches.length} Batches`;
	};

	if (batchList?.length === 0) return <></>;
	return (
		<DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
			<DropdownMenuTrigger asChild>
				<Button
					variant='outline'
					className='flex items-center gap-2 bg-[#FDE6AD] border-yellow-400 hover:bg-yellow-200 text-black max-w-[250px]'
				>
					{isLoading ? (
						<Loader2 className='h-4 w-4 animate-spin' />
					) : (
						<span className='truncate'>
							{getTriggerLabel()}
						</span>
					)}
					{selectedBatches?.length > 0 && (
						<div
							className='p-0.5 hover:bg-yellow-300 rounded-full cursor-pointer shrink-0'
							onClick={clearSelection}
							onPointerDown={(e) => e.stopPropagation()}
						>
							<X size={14} />
						</div>
					)}
					<ChevronDown className='h-4 w-4 opacity-50 shrink-0' />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className='w-80 max-h-[400px] overflow-y-auto'>
				<div className='p-2 sticky top-0 bg-white z-10'>
					<input
						type='text'
						placeholder='Search batches...'
						className='w-full px-2 py-1 text-sm border rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						onClick={(e) => e.stopPropagation()}
					/>
				</div>
				<DropdownMenuSeparator />
				{filteredBatches.length === 0 ? (
					<div className='p-2 text-sm text-center text-gray-500'>
						{isLoading ? 'Loading...' : 'No batches found'}
					</div>
				) : (
					filteredBatches.map((batch) => (
						<DropdownMenuCheckboxItem
							key={batch.grnItemBatchId}
							checked={selectedBatches.some((b) => b.grnItemBatchId === batch.grnItemBatchId)}
							onCheckedChange={() => handleSelect(batch)}
							className='cursor-pointer'
						>
							<div className='flex flex-col items-start gap-0.5'>
								{!variantId && !productId && (
									<span className='font-semibold text-sm'>
										{batch.productName}
										{batch.variantName && (
											<span className='text-xs font-normal ml-1 text-gray-600'>
												(
												{batch.variantName}
												)
											</span>
										)}
									</span>
								)}
								<span className='text-xs text-gray-500 flex items-center gap-2'>
									<span>{batch.batchName}</span>
									{batch.costingDate && !variantId && !productId && (
										<span className='text-gray-400 text-[10px]'>
											•
											{' '}
											{batch.costingDate}
										</span>
									)}
								</span>
							</div>
						</DropdownMenuCheckboxItem>
					))
				)}
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export default BatchPicker;
